import Vue from 'vue';
import Vuex from 'vuex';
import config from 'libs/config.js';
import security from './modules/security.js';
import purchaseReceipt from './modules/purchaseReceipt.js';
import ApiController from 'controller/apicontroller';
import logger from '@/plugins/logger.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    security: security,
    purchaseReceipt: purchaseReceipt
    // workingticket: workingticket,
    // workflow: workflow
  },
  state: {
    debug: debug,
    siteRoot: config.baseuri,
    breadCrumbTitle: '',
    user: null,
    navigationPosition: 0,
    previousNavigationPosition: 0,
    isMobile: false,
    responsiveBreakPoint: ''
  },
  getters: {
    api: state => {
      // return new ApiController(state.siteRoot); dvb
      return new ApiController(state.siteRoot);
    },
    user: state => {
      return state.user;
    },
    backNavigated: state => {
      return state.previousNavigationPosition > state.navigationPosition;
    },
    isMobile: state => state.isMobile,
    responsiveBreakPoint: state => state.responsiveBreakPoint
  },
  mutations: {
    setBreadCrumbTitle (state, title) {
      state.breadCrumbTitle = title;
    },
    setUser (state, user) {
      state.user = user;
    },
    setNavigationPosition (state, count) {
      state.previousNavigationPosition = state.navigationPosition;
      state.navigationPosition = count;
    },
    setIsMobile (state, ismobile) {
      state.isMobile = ismobile;
    },
    setResponsiveBreakPoint (state, breakpoint) {
      state.responsiveBreakPoint = breakpoint;
    }
  },
  actions: {
    async getUser (context, forceUpdate = false) {
      try {
        logger.log('get user');
        if (context.state.user === null || forceUpdate) {
          let result = await this.getters.api.Get('mvc/user/getcurrentuser');
          if (result) {
            context.commit('setUser', result);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
});
